import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadShopData } from "../actions/shopLoadData";
import { IP } from "../config/IP";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
			width: "25ch",
		},
		formControl: {
			margin: theme.spacing(1),
			width: "25ch",
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
		fab: {
			position: "absolute",
			bottom: theme.spacing(2),
			right: theme.spacing(2),
		},

		wrapper: {
			margin: theme.spacing(1),
			position: "relative",
		},
	},
}));

export default function ShopAddProductStockForm(props) {
	const classes = useStyles();
	const quantityRef = useRef();
	const aquisitionDateRef = useRef();
	const aquisitionUnitPriceRef = useRef();
	const currencyRef = useRef();
	const expiryDateRef = useRef();
	const dispatch = useDispatch();

	const state = useSelector((state) => state);
	const [open, setOpen] = React.useState(props.open);
	const [currency, setCurrency] = React.useState();
	const [title, setTitle] = React.useState("");
	const [expiryDate, setExpiryDate] = React.useState();
	const [aquisitionDate, setAquisitionDate] = React.useState();
	const [aquisitionUnitPrice, setAquisitionUnitPrice] = React.useState();
	const [quantity, setQuantity] = React.useState(0);
	let error = {
		quantity: false,
		aquisitionDate: false,
		aquisitionUnitPrice: false,
		currency: false,
		expiryDate: false,
	};
	const [errorv, setErrorv] = useState(error);
	console.log("props.open=", props.open);
	console.log("props.data=", props.data);

	const handleChangeExpiryDate = (event) => {
		console.log("handleChangeExpiryDate=", event.target.value);
		setExpiryDate(event.target.value);
	};

	const handleChangeAquisitionDate = (event) => {
		console.log("handleChangeAquisitionDate=", event.target.value);
		setAquisitionDate(event.target.value);
	};
	const handleChangeAquisitionUnitPrice = (event) => {
		console.log("handleChangeAquisitionUnitPrice=", event.target.value);
		setAquisitionUnitPrice(event.target.value);
	};

	const handleChangeQuantity = (event) => {
		console.log("handleChangeQuantity=", event.target.value);
		setQuantity(event.target.value);
	};

	const handleChangeCurrency = (event) => {
		console.log("handleChangeCurrency=", event.target.value);
		setCurrency(event.target.value);
	};
	const handleSave = async () => {
		let inputs = [
			{ name: "action", value: "insert_new_product_item" },
			{ name: "quantity", value: quantity },
			{
				name: "aquisitionUnitPrice",
				value: aquisitionUnitPrice,
			},
			{ name: "aquisitionDate", value: aquisitionDate },

			{ name: "currency", value: currency },
			{ name: "expiryDate", value: expiryDate },
			{ name: "categoryId", value: props.data.categoryId },
			{
				name: "subCategoryId",
				value: props.data.subCategoryId,
			},
			{
				name: "productId",
				value: props.data.productId,
			},
			,
		];
		console.log("ShopAddProductStockForm inputs=", inputs);

		if (
			quantity &&
			quantity > 0 &&
			aquisitionUnitPrice &&
			aquisitionDate &&
			currency &&
			expiryDate
		) {
			await props.handleSave(inputs);
			inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
				],
			};
			console.log("loadShopData=", inputs);
			dispatch(loadShopData(inputs));
		} else {
			console.log("quantity=", quantity);
			console.log("typeof quantity=", typeof quantity);
			if (typeof quantity === "undefined" || !quantity || quantity <= 0) {
				console.log("ShopAddProductStockForm quantity is null");
				console.log("ShopAddProductStockForm inputs quantity is null=", inputs);
				console.log("error=", error);
				error = { ...error, quantity: true };
			} else {
				error = { ...error, quantity: false };
			}
			if (!aquisitionUnitPrice || aquisitionUnitPrice <= 0) {
				error = { ...error, aquisitionUnitPrice: true };
			} else {
				error = { ...error, aquisitionUnitPrice: false };
			}
			if (!aquisitionDate) {
				error = { ...error, aquisitionDate: true };
			} else {
				error = { ...error, aquisitionDate: false };
			}
			if (!currency) {
				error = { ...error, currency: true };
			} else {
				error = { ...error, currency: false };
			}
			if (!expiryDate) {
				error = { ...error, expiryDate: true };
			} else {
				error = { ...error, expiryDate: false };
			}
			setErrorv(error);
		}
	};

	React.useEffect(() => {
		setOpen(props.open);
	}, [props.open]);
	let response = state.shopData.data;

	React.useEffect(() => {
		try {
			console.log(
				"response.data.filter((x) => x._id === props.data.categoryId)[0].categoryName=",
				response.data.filter((x) => x._id === props.data.categoryId)[0]
					.categoryName
			);

			console.log(
				"response.data.filter((x) => x._id === props.data.categoryId)[0].subCategory.filter((x) => x._id === props.data.subCategoryId)[0].subCategoryName=",
				response.data
					.filter((x) => x._id === props.data.categoryId)[0]
					.subCategory.filter((x) => x._id === props.data.subCategoryId)[0]
					.subCategoryName
			);
			console.log(
				"response.data.filter((x) => x._id === props.data.categoryId)[0].subCategory.filter((x) => x._id === props.data.subCategoryId)[0].productItems.filter((x) => x._id === props.data.productId)[0].productName=",
				response.data
					.filter((x) => x._id === props.data.categoryId)[0]
					.subCategory.filter((x) => x._id === props.data.subCategoryId)[0]
					.productItems.filter((x) => x._id === props.data.productId)[0]
					.productName
			);
			setTitle(
				response.data.filter((x) => x._id === props.data.categoryId)[0]
					.categoryName +
					">>" +
					response.data
						.filter((x) => x._id === props.data.categoryId)[0]
						.subCategory.filter((x) => x._id === props.data.subCategoryId)[0]
						.subCategoryName +
					">>" +
					response.data
						.filter((x) => x._id === props.data.categoryId)[0]
						.subCategory.filter((x) => x._id === props.data.subCategoryId)[0]
						.productItems.filter((x) => x._id === props.data.productId)[0]
						.productName
			);
		} catch (e) {}
	}, []);
	React.useEffect(() => {
		if (state.shopSaveInfo.isSaved) {
			console.log(
				"ShopAddProductStockForm state.shopSaveInfo=",
				state.shopSaveInfo
			);
			props.loadingData();
			props.handleClose();
		}
	}, [state.shopSaveInfo.isSaved]);

	console.log("ShopAddProductStockForm state=", response);

	console.log("ShopAddProductStockForm error=", error);
	return (
		<div>
			<Dialog
				open={open}
				onClose={props.handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					add to stock to "{title}"
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						To add stock the the product , please record below information.
					</DialogContentText>
					<TextField
						ref={quantityRef}
						error={errorv.quantity}
						autoFocus
						margin="dense"
						id="quantity"
						label="quantity"
						type="number"
						fullWidth
						onChange={handleChangeQuantity}
					/>

					<TextField
						ref={aquisitionDateRef}
						error={errorv.aquisitionDate}
						autoFocus
						id="aquisitionDate"
						label="aquisitionDate"
						type="date"
						defaultValue={new Date()}
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
						onChange={handleChangeAquisitionDate}
					/>
					<TextField
						ref={aquisitionUnitPriceRef}
						error={errorv.aquisitionUnitPrice}
						autoFocus
						margin="dense"
						id="aquisitionUnitPrice"
						label="aquisitionUnitPrice"
						type="number"
						onChange={handleChangeAquisitionUnitPrice}
					/>
					<TextField
						ref={currencyRef}
						error={errorv.currency}
						id="standard-select-currency"
						select
						label="currency"
						Defaultvalue={currency}
						helperText="Please select your currency"
						onChange={handleChangeCurrency}
					>
						<MenuItem value={"RWF"}>RWF</MenuItem>
					</TextField>

					<TextField
						ref={expiryDateRef}
						error={errorv.expiryDate}
						id="expiryDate"
						label="expiryDate"
						type="date"
						defaultValue={new Date()}
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
						onChange={handleChangeExpiryDate}
						fullWidth
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={() => handleSave()} color="primary">
						Record
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
